<template>
  <div class="login-container">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Login'
}
</script>

<style lang="stylus">
.login-container
  position absolute
  top 0
  left 0
  width 100%
  height 100%
  background url('../assets/images/bg.jpg') no-repeat
  background-position 50% 50%
  background-size cover
</style>